// This is used to determine if a user is authenticated and
// if they are allowed to visit the page they navigated to.

// If they are: they proceed to the page
// If not: they are redirected to the login page.
import React from 'react'
import { Redirect, Route, withRouter } from 'react-router-dom'
import { connect } from 'react-redux';

const AuthenticatedRoute = ({ component: Component, ...rest }) => {
  if(rest.currentUser && rest.currentUser.isLoading) {return null}

  // Add your own authentication on the below line.
  const isLoggedIn = rest.currentUser && rest.currentUser.isSignedIn

  return (
    <Route exact
      {...rest}
      
      render={(props) =>
        isLoggedIn ? (
          <Component currentUser={rest.currentUser} {...props} />
        ) : (
          <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
        )
      }
    />
  )
}

const mapStateToProps = (state) => ({
  currentUser: state.reduxTokenAuth.currentUser
})

export default withRouter(connect(mapStateToProps, null)(AuthenticatedRoute))


// WEBPACK FOOTER //
// ./src/shared/javascripts/components/AuthenticatedRoute.jsx